// extracted by mini-css-extract-plugin
module.exports = {"root":"Page_root__1tAVz","content":"Page_content__3NC8p","scrollingDisabled":"Page_scrollingDisabled__s_pdi"};